import React, { useCallback, useState } from 'react';
import Link from 'react-router-dom/Link';
import { MultiColorIcon } from '@tt/ui';
import PropTypes from 'prop-types';

import Avatar from '../../../../../components/Avatar';
import Button from '../../../../../components/Button';
import Card from '../../../../../components/Card';
import { H2, H5, Paragraph } from '../../../../../components/Typography';
import VideoPlayerModal from '../../../../../components/VideoPlayerModal';
import { useConfig } from '../../../../../providers/ConfigProvider';
import { segmentTracking } from '../../../../../services/utilities';

import styles from './HowItWorks.module.scss';

const HowItWorks = ({ location, variant }) => {
  const RP_VIDEO_URL = 'https://player.vimeo.com/video/684816042';
  const { PRIVATE_BASE_PATH } = useConfig();
  const [play, setPlay] = useState(false);

  const onTrackClick = useCallback(
    (eventName) => {
      segmentTracking(`${eventName} clicked`, {
        location,
      });
    },
    [location],
  );

  return (
    <Card className={styles.card} padded>
      <H2 className={styles.title}>{variant.title}</H2>
      <div className={styles.container}>
        {variant.blocks.map((block) => (
          <div key={block.title} className={styles.block}>
            <Avatar className={styles.icon}>
              <MultiColorIcon name={block.icon} />
            </Avatar>
            <div className={styles.content}>
              <H5>{block.title}</H5>
              <Paragraph>
                {block.description}
                {block.link && (
                  <Link
                    onClick={() => {
                      segmentTracking(block.link.trackingEvent, {
                        location,
                      });
                      setPlay(true);
                    }}
                    to={block.link.to}
                  >
                    {block.link.text}
                  </Link>
                )}
              </Paragraph>
            </div>
          </div>
        ))}
        <Button
          variant="primary"
          className={styles.button}
          onClick={() => onTrackClick('setup_rent_collection')}
          to={`${PRIVATE_BASE_PATH}payments/setup/lease`}
        >
          {variant.buttonText}
        </Button>
      </div>
      {play && (
        <VideoPlayerModal
          onClose={() => setPlay(false)}
          url={RP_VIDEO_URL}
          open={play}
        />
      )}
    </Card>
  );
};

HowItWorks.propTypes = {
  location: PropTypes.string,
  variant: PropTypes.shape({
    title: PropTypes.node,
    blocks: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        link: PropTypes.shape({
          text: PropTypes.string,
          trackingEvent: PropTypes.string,
        }),
      }),
    ),
    buttonText: PropTypes.string,
  }),
};

export default HowItWorks;
